import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import AddOutline from '@material-ui/icons/AddCircleOutline';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import NewColumnDetailContainer from './newColumnDetail.container';

const styles = () => ({
  buttonCell: {
    padding: '25px 0px',
    textAlign: 'center',
  },
  button: {
    float: 'right',
  },
});

class NewColumnDialogComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      open: false,
    };
  }

  handleClickOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  render() {
    const {
      classes,
      metadata,
      isVirtualFile,
    } = this.props;

    return (
      <React.Fragment>
        <IconButton className={classes.button} onClick={this.handleClickOpen} >
          <AddOutline />
        </IconButton>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">New Column</DialogTitle>
          <DialogContent className={this.props.classes.dialog}>
            <NewColumnDetailContainer
              isVirtualFile={isVirtualFile}
              metadata={metadata}
              closeDialog={this.handleClose}
            />
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}

NewColumnDialogComponent.propTypes = {
  isVirtualFile: PropTypes.bool.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  metadata: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(NewColumnDialogComponent);
